"use client";
import { useState, useEffect } from "react";
import { getAllDesignProductTemplates } from "../../services/axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  deleteDesignProductTemplate,
  disableDesignProductTemplate,
  DesignProductTemplate,
} from "../../services/axios";
import { toast } from "sonner";
import { designAreaLabel } from "../../utils/design-areas";

export const DesignProductTemplates = () => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const getTemplates = async () => {
      const request = await getAllDesignProductTemplates();
      console.log("request", request);
      setTemplates(request);
    };
    getTemplates();
  }, []);

  const templateColumns: any[] = [
    {
      headerName: "id",
      field: "id",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Created",
      field: "created_at",
      valueFormatter: milliSecondToDate,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Updated",
      field: "updated_at",
      valueFormatter: milliSecondToDate,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "campaign",
      field: "campaign",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Handle",
      field: "handle",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "body_html",
      field: "body_html",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Title",
      field: "title",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Organization",
      field: "organization",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "File",
      field: "file",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Sku",
      field: "sku",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Variants",
      field: "variants",
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Layers",
      field: "layers",
      valueFormatter: formatArrays,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Design Area",
      field: "design_area",
      valueFormatter: formatDesignArea,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Licensing",
      field: "licensing",
      valueFormatter: formatArrays,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Stores",
      field: "stores",
      valueFormatter: formatArrays,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Colleges",
      field: "college_names",
      valueFormatter: formatArrays,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Organizations",
      field: "college_names",
      valueFormatter: formatArrays,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Org SF Ids",
      field: "org_salesforce_ids",
      valueFormatter: formatArrays,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "UPIs",
      field: "upis",
      valueFormatter: formatArrays,
      filterParams: {
        showTooltips: true,
      },
    },
    {
      headerName: "Auto Run",
      field: "auto_run",
      valueFormatter: formatBoolean,
    },
    {
      headerName: "Actions",
      field: "actions",
      suppressMovable: true,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => actions(params.data),
    },
  ];

  const actions = (item: any) => {
    console.log("item", item);
    return (
      <div className="flex flex-row items-center justify-center">
        <button
          onClick={() => deleteTemplate(item.id)}
          className="px-4 py-2 border"
        >
          Delete
        </button>
        <button
          onClick={() => disableTemplate(item.id, !item.disabled)}
          className="px-4 py-2 border"
        >
          {item.disabled ? "Disabled" : "Enabled"}
        </button>
      </div>
    );
  };

  function deleteTemplate(id: any) {
    return deleteDesignProductTemplate(id)
      .then(() => {
        toast.success(`deleted`, { duration: 5000 });
      })
      .catch((e) => toast.error(e.message, { duration: 5000 }));
  }

  function disableTemplate(id: string, disabled: boolean) {
    return disableDesignProductTemplate(id, disabled)
      .then(() => {
        toast.success(`disabled`, { duration: 5000 });
      })
      .catch((e) => toast.error(e.message, { duration: 5000 }));
  }

  function convertETC(etc: number) {
    const converted = new Date(etc);
    if (!isValidDate(converted)) {
      return "error";
    }
    return converted.toString();
  }

  function milliSecondToDate(m: any) {
    let val = Number(m.value);
    return convertETC(val);
  }

  function isValidDate(d: any) {
    return d instanceof Date;
  }

  function formatArrays(a: any) {
    return a.value.join(",");
  }

  function formatDesignArea(a: any) {
    return designAreaLabel(a.value);
  }

  function formatBoolean(b: any) {
    return `${b}`;
  }

  return (
    <main className="flex min-h-screen flex-col items-center justify-between p-8 md:p-24">
      <div className="mt-8 flex flex-col justify-center items-center">
        <h1>Templates</h1>
        <div
          className="ag-theme-alpine mt-8"
          style={{ height: 400, width: 800 }}
        >
          <AgGridReact
            defaultColDef={{
              sortable: true,
              filter: true,
              resizable: true,
              minWidth: 150,
              flex: 1,
            }}
            rowData={templates}
            columnDefs={templateColumns}
          ></AgGridReact>
        </div>
      </div>
    </main>
  );
};
